<template lang="pug">
    .component-backoffice-attachment(v-if="item")
      .row
        .column
          img(:src="item.url")
          a.button.button-download.expanded(v-on:click="openUrl(item.url)") Download

</template>

<script type="text/babel">

    export default {
        name: "BackofficeAttachment",
        props: {
            item: Object,
            type: {
                type: String,
                default: ''
            }
        },
        components: {
        },
        created() {
        },
        methods: {
            openUrl: function (url) {
                window.open(url, '_blank')
            },
        },
    }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Attachment.vue?6cd58702